import { Forteckningstransaktion } from '../types/Forteckningstransaktion';

export const toForteckningstransaktioner = (
  transaktioner: string[]
): Forteckningstransaktion[] => {
  const nameMap = {
    METAGF: 'Ägarförteckning',
    METAGRA: 'Ägare + rättigheter',
    METAGADR: 'Ägare + belägenhetsadresser',
    METAGLATA: 'Ägarförteckning samtliga ägare',
  };

  return transaktioner
    .map((forteckningstyp) =>
      nameMap[forteckningstyp]
        ? {
            transactionId: forteckningstyp,
            name: nameMap[forteckningstyp],
          }
        : undefined
    )
    .filter((forteckningstransaktion) => !!forteckningstransaktion);
};
